import { render, staticRenderFns } from "./statisticsPane.vue?vue&type=template&id=0d574bfa&scoped=true"
import script from "./statisticsPane.vue?vue&type=script&lang=js"
export * from "./statisticsPane.vue?vue&type=script&lang=js"
import style0 from "./statisticsPane.vue?vue&type=style&index=0&id=0d574bfa&prod&lang=scss"
import style1 from "./statisticsPane.vue?vue&type=style&index=1&id=0d574bfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d574bfa",
  null
  
)

export default component.exports